import {
  IAssignMenuToUserPayload,
  IAssignedMenusUserResponse,
  IMenuFormData,
  IMenusListResponse,
} from "../../../features/menus/types";
import { IStatusRepsonse } from "../../../Types/UserProfileDetails";
import ApiService from "../../ApiService";

class MenusService extends ApiService {
  async getMenus() {
    return this.get<IMenusListResponse>("/menus");
  }

  async createMenu(data: IMenuFormData) {
    return this.post<IStatusRepsonse>("/menus", data);
  }

  async updateMenu(id: number, data: IMenuFormData) {
    return this.put<IStatusRepsonse>(`/menus/${id}`, data);
  }

  async deleteMenu(id: number) {
    return this.delete<IStatusRepsonse>(`/menus/${id}`);
  }

  async assignMenuToUser(payload: IAssignMenuToUserPayload) {
    return this.post<IStatusRepsonse>(`/menus/assign`, payload);
  }

  async assignMenusUser(userId: number) {
    return this.get<IAssignedMenusUserResponse>(`/users/${userId}/menus`);
  }
}

export const menusService = new MenusService();
